module.exports = __webpack_public_path__ + "static/media/close-icon.c16a38f6.svg";